import classNames from "classnames/bind";
import React from "react";
import { ButtonToggleGroup } from "../../ButtonToggleGroup";
import styles from "./DropdownInput.module.scss";
import { useDropdownContext } from "./DropdownContext";
const cx = classNames.bind(styles);

const DropdownGroupSelector = () => {
  const {
    activeGroup,
    setActiveGroup,
    getLabel,
    getValue,
    groups,
    onGroupChange,
  } = useDropdownContext();

  const items = groups?.map((option) => ({
    label: getLabel(option),
    dataKey: getValue(option),
  }));

  if (!Array.isArray(items) || items.length === 0) return null;

  return (
    <ButtonToggleGroup
      name="dropdown-group-button-toggle-group"
      items={items}
      activeKey={activeGroup ?? ""}
      className={cx("group-switcher")}
      onChange={(tab) => {
        setActiveGroup(tab);
        onGroupChange?.(tab);
      }}
    />
  );
};

export default DropdownGroupSelector;
